import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { Ref } from 'react'

import { EyeIcon } from '../Icons/EyeIcon'
import { EyeSlashedOutIcon } from '../Icons/EyeSlashedOutIcon'

interface VisibilityIconButtonProps
  extends Omit<IconButtonProps, 'aria-label'> {
  ref?: Ref<HTMLButtonElement>
}

export const VisibleIconButton = ({
  onClick,
  ref,
  ...props
}: VisibilityIconButtonProps) => (
  <IconButton
    ref={ref}
    aria-label="Hide"
    fontSize="22px"
    padding="15px"
    boxSize="20px"
    color="presets.turquoise.60"
    _hover={{
      color: 'presets.turquoise.60',
      bgColor: 'presets.neutral.20',
      opacity: '0.7',
    }}
    icon={<EyeIcon />}
    onClick={onClick}
    {...props}
  />
)

export const HiddenIconButton = ({
  onClick,
  ref,
  ...props
}: VisibilityIconButtonProps) => (
  <IconButton
    ref={ref}
    aria-label="Unhide"
    fontSize="22px"
    padding="15px"
    boxSize="20px"
    color="presets.neutral.40"
    _hover={{
      color: 'presets.turquoise.60',
      bgColor: 'presets.neutral.20',
      opacity: '1',
    }}
    icon={<EyeSlashedOutIcon />}
    onClick={onClick}
    {...props}
  />
)
